import { getDateInFormat, getFinancialYear, getThisMonthDateRange, } from "@domains/utils/reportDates";
import { accountDetails } from "@di";
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import "@frameworks/web/stylesheets/components/Reports/TransactionHistory/TransactionHistoryMain.scss";
import "@frameworks/web/stylesheets/components/Reports/TransactionHistory/TransactionHistoryMobile.scss";
import ApproximateTransaction from "./ApproximateTransaction";
import txnDI from "@frameworks/web/components/Reports/TransactionHistory/di/servicelocator";
import { THdefaultPageSize, } from "@domains/entities/interfaces/Reports/TransactionHistory/ITransactionHistory";
import { useSelector } from "react-redux";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import BreadCrumb from "@frameworks/web/components/generic/BreadCrumb";
import { THVIEWS } from "./Constant";
import PNLDI from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
import ApproximateTxnBanner from "./ChildComponents/ApproximateTxnBanner";
import TransactionList from "./TransactionList";
import FilterSection from "./ChildComponents/FilterSection";
import TxnHistoryPageTitle from "./ChildComponents/TxnHistoryPageTitle";
import { EReportRoutes, reportsRoutePaths, } from "@frameworks/web/components/constant";
import DownloadTransactionHistory from "./ChildComponents/DownloadTransactionHistory";
import EditTransactionsMain from "./EditTransactionsMain";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { AssetType } from "@domains/aggregates/interfaces/Reports/iPNLReport";
const TransactionHistoryMain = () => {
    const device = DeviceContext();
    const { reducersData: THData, commonData: THCommonData } = useSelector((state) => state.TransactionHistory.transactionHistory);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [endDate, setEndDate] = React.useState(null);
    const [startDate, setStartDate] = React.useState(null);
    const [openDownloadPopup, setOpenDownloadPopup] = useState(false);
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [currentPage, setCurrPageNumber] = useState(1);
    const [editTransaction, seteditTransaction] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [THViews, setTHViews] = React.useState(THVIEWS.MAIN_LANDING);
    const [showAlltxnsOfSelectedScrip, setShowAlltxnsOfSelectedScrip] = useState(false);
    const [accType, setAccType] = React.useState(null);
    const [COMEQTOGGLE, setCOMEQTOGGLE] = React.useState(null);
    const breadCrumblist = () => {
        if (showAlltxnsOfSelectedScrip && selectedRow)
            return [
                {
                    title: "Dashboard",
                    link: "/",
                },
                {
                    title: "Transaction History",
                    onClick: () => {
                        setShowAlltxnsOfSelectedScrip(false);
                        setSelectedRow(null);
                    },
                    link: reportsRoutePaths[EReportRoutes.transactionHistory],
                },
                {
                    title: `All Transctions of ${selectedRow.security}`,
                },
            ];
        return [
            {
                title: "Dashboard",
                link: "/",
            },
            {
                title: "Transaction History",
            },
        ];
    };
    const getEditableTxns = (showAlltxnsOfSelectedScrip) => {
        return showAlltxnsOfSelectedScrip && selectedRow
            ? THData.editableTxns.filter((x) => x.scripIdentifier === selectedRow.scripIdentifier)
            : THData.editableTxns;
    };
    const gotoEditTransaction = (row) => {
        setSelectedRow(row);
        setShowAlltxnsOfSelectedScrip(false);
        let payload = {
            pnLEditSplitRequests: [{ transactionId: row.tranId }],
        };
        PNLDI.pnlTransactionReport.getOriginalTxns(payload);
    };
    const assetType = () => COMEQTOGGLE === ILoginAccountTypes.EQ ? "" : AssetType.DCommodity;
    const getAllTransactionHistory = () => {
        //page number not required
        if (startDate && endDate && accType) {
            let payload = {
                fromDate: getDateInFormat(startDate, "YYYY-MM-DD"),
                toDate: getDateInFormat(endDate, "YYYY-MM-DD"),
                pageSize: THdefaultPageSize,
                pageNumber: 1,
                assetType: assetType(),
            };
            txnDI.transactionHistory.getAllTransactionHistory(payload, device === null || device === void 0 ? void 0 : device.isDesktop);
        }
    };
    React.useEffect(() => {
        accountDetails.getAccTyp().then((val) => {
            setAccType(val);
        });
    }, []);
    useEffect(() => {
        if (accType) {
            let defaultAccType = accType === ILoginAccountTypes.COMEQ ||
                accType === ILoginAccountTypes.EQ
                ? ILoginAccountTypes.EQ
                : ILoginAccountTypes.CO;
            setCOMEQTOGGLE(defaultAccType);
        }
    }, [accType]);
    useEffect(() => {
        // When date changes reset  to default
        window.scrollTo({ behavior: "smooth", top: 0 });
        setShowAlltxnsOfSelectedScrip(false);
        setSelectedRow(null);
        setTHViews(THVIEWS.MAIN_LANDING);
        setCurrPageNumber(1);
        if (COMEQTOGGLE) {
            getAllTransactionHistory();
        }
    }, [startDate, endDate, COMEQTOGGLE]);
    React.useEffect(() => {
        let { endDate, startDate } = getThisMonthDateRange();
        setFinYear(getFinancialYear(startDate));
        setStartDate(startDate);
        setEndDate(endDate);
        PNLDI.pnlTransactionReport.resetEditTransaction();
        //only for first landing
        txnDI.transactionHistory.resetFilterAndSearch();
    }, []);
    const renderTHViews = () => {
        switch (THViews) {
            case THVIEWS.APPROXIMATEDTXNS:
                return (React.createElement("div", { className: "approximate-transaction my-4" },
                    React.createElement(ApproximateTransaction, { setTHViews: setTHViews, seteditTransaction: seteditTransaction, handleRowClick: setSelectedRow, startDate: startDate, endDate: endDate, editableTxns: getEditableTxns(showAlltxnsOfSelectedScrip) })));
            case THVIEWS.MAIN_LANDING:
                return (React.createElement("div", null,
                    (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "mt-3 txn-history-breadcrumb" },
                        React.createElement(BreadCrumb, { list: breadCrumblist() }))),
                    React.createElement(ApproximateTxnBanner, { allTHloader: THData === null || THData === void 0 ? void 0 : THData.allTxnLoader, editableTxnCount: getEditableTxns(showAlltxnsOfSelectedScrip).length, showApproximatedTxns: () => setTHViews(THVIEWS.APPROXIMATEDTXNS) }),
                    React.createElement("div", { className: "sticky-txn-filterbar" },
                        React.createElement(TxnHistoryPageTitle, { showCOMEQTOGGLE: accType === ILoginAccountTypes.COMEQ, COMEQTOGGLE: COMEQTOGGLE, setCOMEQTOGGLE: setCOMEQTOGGLE }),
                        React.createElement(FilterSection, { isFilterApplied: isFilterApplied, setIsFilterApplied: setIsFilterApplied, startDate: startDate, endDate: endDate, setStartDate: setStartDate, setEndDate: setEndDate, finYear: finYear, setFinYear: setFinYear, setOpenDownloadPopup: setOpenDownloadPopup, showAlltxnsOfSelectedScrip: showAlltxnsOfSelectedScrip })),
                    React.createElement("div", { className: "position-relative" },
                        React.createElement(TransactionList, { selectedTxnRow: selectedRow, setSelectedTxnRow: setSelectedRow, startDate: startDate, endDate: endDate, showAlltxnsOfSelectedScrip: showAlltxnsOfSelectedScrip, setShowAlltxnsOfSelectedScrip: setShowAlltxnsOfSelectedScrip, setTHViews: setTHViews, gotoEditTransaction: gotoEditTransaction }))));
        }
    };
    return (React.createElement(GridContainer, { parentClass: "px-0" },
        React.createElement("div", { className: `transaction-history-container` },
            renderTHViews(),
            React.createElement(DownloadTransactionHistory, { startDate: startDate, endDate: endDate, openDownloadPopup: openDownloadPopup, setOpenDownloadPopup: setOpenDownloadPopup, showAlltxnsOfSelectedScrip: showAlltxnsOfSelectedScrip, selectedTxnRow: selectedRow }),
            React.createElement(EditTransactionsMain, { editTransaction: editTransaction, setEditTransaction: seteditTransaction, selectedTxnRow: selectedRow, setSelectedTxnRow: setSelectedRow, endDate: endDate, startDate: startDate, showAlltxnsOfSelectedScrip: showAlltxnsOfSelectedScrip, getAllTransactionHistory: getAllTransactionHistory, txnHistoryView: THViews }))));
};
export default TransactionHistoryMain;
